<template>
  <!-- Layout Header ( Navbar ) -->
  <!-- <el-affix :offset="1"> -->
  <div>
    <div class="bg-header">
      <MenuTop></MenuTop>
      <div>
        <a-layout-header id="header" class="header d-flex align-items-center sticky-top">
          <div class="container-fluid position-relative d-flex flex-column align-items-center justify-content-between">
            <!-- <div class="logo d-flex align-items-center me-xl-0" @click="goHome">
              <el-image style="width: 250px" :src="companys.logo" fit="contain" />
            </div> -->

            <div class="header-logo-section">
              <div class="container">
                <router-link to="/" class="logo">
                  <h1 class="logo-text">{{ companys.sub_name}}</h1>
                  <div class="logo-bg"></div>
                  <div class="logo-tagline">{{ companys.summary}}</div>
                </router-link>
              </div>
            </div>


            <nav id="navmenu" class="navmenu">
              <a-anchor style=" width: 100% !important;">
                <!-- <MenuWebsite :data-menu="menuHeader"></MenuWebsite> -->
                <HeaderMenu :dataMenu="menuDefault" @openMenuMobile="showDrawer"></HeaderMenu>
              </a-anchor>
            </nav>
            <!-- <a class="btn-getstarted" href="#about">Get Started</a> -->
          </div>
        </a-layout-header>
        <!-- / Layout Header ( Navbar ) -->
        <Drawer placement="left" :show-form="showMenu" @closePopup="closePopup">
          <template #content>
            <div>
              <MenuMobile :data-menu="menuDefault"></MenuMobile>
            </div>
          </template>
        </Drawer>
      </div>

    </div>
    <PageBanner></PageBanner>
    <DefaultBreadcrumb></DefaultBreadcrumb>
  </div>
  <!-- </el-affix> -->
</template>

<script setup lang="ts">
import { ref, onMounted, watch, h, computed } from "vue";
import { V1_REDIS_GET_KEY } from "@/api/const/redis";
import { apiPost, apiGetNoParam, apiRedis } from "@/api/index";
import MenuTop from "@/components/Headers/default/menu/MenuTop.vue";
import Drawer from "@/components/ant/drawer/Drawer.vue";
import MenuMobile from "@/components/Headers/default/menu/MenuMobile.vue";
import HeaderMenu from "@/components/Headers/default/menu/HeaderMenu.vue";
import commons from "@/utils/Common";
import router from "@/router";
import redis from '@/redis/Redis'
import { MENU_HEADER_TOP1_COOKIE, COMPANY_DETAIL_COOKIE } from '@/const/ConstCookies'
import {COOKIE_COMPANY_SESSION} from '@/const/cookie'
import store from "@/store";
import Utils from "@/utils/Utils";
import PageBanner from '@/components/ant/pagebaner/PageBanner.vue'
import DefaultBreadcrumb from '@/components/ant/breadcrumb/DefaultBreadcrumb.vue'
const menuHeader: any = ref([]);
const menuDefault: any = ref([]);

const companys: any = ref({});
onMounted(async () => {
  await informMenu();
  await loadCompanyInform();
});

const showMenu = ref(false);
const showDrawer = () => {
  showMenu.value = true;
};

const informMenu = async () => {
  loadMenuHeaderTop()
  loadMenuDefault()
};

const loadMenuHeaderTop = async () => {
  await apiGetNoParam(
    V1_REDIS_GET_KEY + "?key=menu-top-header"
  ).then((res) => {
    let response: any = res;
    let data = response.data.data
    commons.setLocalStorage(MENU_HEADER_TOP1_COOKIE, data)
    let menuTop = JSON.parse(commons.getLocalStorage(MENU_HEADER_TOP1_COOKIE) || 'null')
    menuHeader.value = menuTop;
  });
}

const loadMenuDefault = async () => {
  await apiRedis("default-menu-header").then((res) => {
    let response: any = res;
    let data = response.data.data
     if (typeof data === "string") {
      data = JSON.parse(data)
    }

    menuDefault.value = data || []


    // commons.setLocalStorage(MENU_HEADER_TOP1_COOKIE, data)
    // let menuTop = JSON.parse(commons.getLocalStorage(MENU_HEADER_TOP1_COOKIE) || 'null')
    // menuHeader.value = menuTop;
  });
}

const loadCompanyInform = async () => {
  await apiRedis("company-infor").then((res) => {
    let response: any = res;
    let data = JSON.parse(response.data.data)
    console.log('company-infor', data[0])
    commons.setCokies(COOKIE_COMPANY_SESSION, data[0])
    companys.value = data[0];
    store.dispatch('setCompanyInfor', data[0])
  });
}

const closePopup = (val: any) => {
  showMenu.value = val;
};

const goHome = () => {
  router.push({ path: "/" });
};

</script>

<style lang="scss">
.logo-bg {
  height: 15px;
  background-image: url(../../assets/client/img/bg/banner-bg.png);
  width: 100%;
  background-repeat: no-repeat;
  background-size: revert;
  /* hoặc cover */
  background-position: center;
}

.bg-header {
  background-color: #102542;
}

.logo:hover {
  cursor: pointer;
}

#navmenu {
  width: 100%;
}

.navmenu i {
  color: #b19663;
}

#menu-btn:checked~.nav-links-menu {
  left: 0%;
}

#menu-btn:checked~.btn.menu-btn {
  display: none;
}

#close-btn:checked~.btn.menu-btn {
  display: block;
}

.boder-bottom {
  border-bottom: 1px dashed #ccc;
}

// @media screen and (max-width: 1199px) {

// }
// @media screen and (min-width: 1200) {
//   .nav-mobile {
//     display: none !important
//   }
// }
.nav-mobile {

  text-align: right;
}

.nav-mobile i {
  font-size: 24px;
}

@media only screen and (min-width: 360px) and (max-width: 1199px) {
  .nav-mobile {
    display: block !important;
  }

  .nav-website {
    display: none !important;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 2000px) {
  .nav-mobile {
    display: none !important;
  }

  .nav-website {
    display: block !important;
  }
}

// .layout-default .header {
//   margin: 10px;
// }
// .bg-header {
//   background-color: #fff !important
// }

.header {
  background: var(--primary-dark);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.header-top {
  background: var(--primary-dark);
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 13px;
  color: #aaa;
}

.header-top .header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: none;
  padding: 0 40px;
  /* Add some padding if full width */
}

.header-left,
.header-right {
  display: flex;
  align-items: center;
}

.top-link {
  color: #aaa;
  text-decoration: none;
  transition: color 0.3s;
  text-transform: capitalize;
  /* Image shows normal case/capitalize */
  font-size: 12px;
}

.top-link:hover {
  color: var(--primary-gold);
}

.separator {
  display: inline-block;
  margin: 0 15px;
  /* Wider spacing */
  height: 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.language-selector {
  color: #aaa;
  font-size: 12px;
  display: flex;
  gap: 8px;
  cursor: pointer;
  text-transform: uppercase;
}

.language-selector span.active {
  color: #fff;
  font-weight: 600;
}

.header-logo-section {
  text-align: center;
  background: var(--primary-dark);
}

.logo {
  display: inline-block;
  text-decoration: none;
}

.logo-text {
  font-size: 48px;
  color: var(--default-header-color);
  margin: 0;
  letter-spacing: 4px;
  font-family: 'Playfair Display', serif !important;
  line-height: 1;
}

.logo-tagline {
  font-size: 12px;
  line-height: 40px;
  color: var(--default-header-color);
  // margin-top: 8px;
  letter-spacing: 6px;
  text-transform: uppercase;
  font-family: 'Lato', sans-serif;
}
</style>
